import React, { Component } from "react";
import Preloader from "app/shared/components/Preloader";
import Url from "app/shared/constants/Url";

/**
 * Lightweight landing page for the "Start Your Course" email link flow.
 *
 * Flow:
 *  1. Spring /course/email-start validates the one-time token and starts the
 *     course progress in the DB, then redirects here with ?courseId=&sub_domain=
 *  2. This page stores the intended destination in sessionStorage so it survives
 *     the upcoming SSO redirect chain (same browser tab → sessionStorage persists).
 *  3. It then triggers SSO login for the correct tenant.
 *  4. After SSO login the /sso-callback page reads sessionStorage and navigates
 *     the user directly to the course detail page.
 */
class EmailCourseStart extends Component {
  componentDidMount() {
    const params    = new URLSearchParams(window.location.search);
    const courseId  = params.get("courseId");
    const subDomain = params.get("sub_domain");

    if (courseId) {
      // Persist the destination so SsoCallback can pick it up after login
      sessionStorage.setItem(
        "post_sso_redirect",
        `/elearning/${courseId}/course-detail`
      );
    }

    // Trigger SSO login for this tenant
    const ssoLoginUrl = `${Url.ssoLogin}?sub_domain=${encodeURIComponent(subDomain || "")}`;
    window.location.href = ssoLoginUrl;
  }

  render() {
    // Show the app's spinner while the redirect is in flight
    return <Preloader />;
  }
}

export default EmailCourseStart;
